<template>
  <DrawerVue :refreshDisplay="refreshDisplay" v-if="slotData">
    <v-container>
      <v-row class="mb-4">
        <v-col cols="12">
          <h2>
            {{ $t("messages.cancelAppointmentRequest") }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="appointmentCancelForm">
        <v-row>
          <v-col>
            <div v-html='$t("messages.cancelAppointmentInfoText", {
              date: slotData.display_date,
              startTime: slotData.time_units[0].readable_start_time,
              endTime: slotData.time_units[slotData.time_units.length - 1].readable_end_time,
              therapist: slotData.teachers[0]?.full_name
            })'></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" :loading="loading" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "appointmentRequestDeletionComponent",

  props: ["refreshDisplay", "slotData"],

  emits: ["close"],

  data() {
    return {
      loading: false,
    };
  },

  watch: {
    refreshDisplay() {
      if (this.refreshDisplay) {
        this.loading = false
      }
    },
  },

  computed: {
  },

  methods: {
    async confirm() {
      const { valid } = await this.$refs.appointmentCancelForm.validate();

      if (valid) {
        this.loading = true

        let formData = {
          id: this.slotData.id
        };

        this.deleteData(formData);
      }
    },
    deleteData(formData) {
      this.axios
        .delete(this.axios.defaults.baseURL + "calendar/timeslots/request/delete/" + this.slotData.id, formData)
        .then((resp) => {
          this.$emit("close", 1);
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },

  mounted() {
  },
};
</script>
